<template>
    <div class="fullscreen bg_report">
        <div class="menu" @click="showFullSwiper">
        </div>
        <header class="flex_center">
            <div class="flex_align">
                <div class="logo--company">
                    <div class="pic">
                        <img :src="logo" alt="logo">
                    </div>
                </div>
                <p class="title ml_15">我的业绩报告</p>
            </div>
            <div class="year_select_box">
                <el-select v-model="currentYear" popper-class="zfyx_select_dropdown" @change="changeYear"
                    placeholder="请选择">
                    <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </header>

        <div class="main flex_justify_between">
            <div class="main--left">
                <div class="box_normal h_left_top subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15">
                        我的战略伙伴开工建面
                        <div class="unit">({{ partnerBuildData.Header }})</div>
                    </div>
                    <Loading v-if="parBuildLoading" class="partnerMain_left"></Loading>
                    <template v-else>
                        <div class="progressbarList partnerMain_left mt_5"
                            v-if="partnerBuildData && partnerBuildData.aList">
                            <ScrollBox :num='partnerBuildData.aList.length'>
                                <ul slot="main">
                                    <li class="item" v-for="(item, index) in partnerBuildData.aList" :key="index">
                                        <div class="label">{{ item.sCompany }}</div>
                                        <div class="valueBar flex_align">
                                            <div class="innerBar blue"
                                                :style="{ 'width': item.TotalBuildArea_ / partnerBuildData.AllArea * 100 + '%' }">
                                                <div class="innerSplit"></div>
                                            </div>
                                        </div>
                                        <div class="value">
                                            {{ item.TotalBuildArea }}
                                        </div>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <Empty v-else></Empty>
                    </template>
                </div>
                <div class="box_normal h_left_bottom subscript right_bottom left_top">
                    <div class="box_news_title">百强房企战略合作占比</div>
                    <div class="box_chart--drop">
                        <Loading v-if="coverLoading"></Loading>
                        <Echarts v-else :options="getOptions('drop', companyPartnerCoverData)"></Echarts>
                    </div>
                </div>
            </div>
            <div class="main--middle">
                <div class="box_chart--doubleLine mb_20">
                    <Loading v-if="countMoneyLoading" :isMask="true"></Loading>
                    <div class="detailBox">
                        <div class="item">
                            <p class="label">{{ currentYear }}年企业中标项目数量({{ countMoneyHead.sProjectHeader }})</p>
                            <p>
                                <span class="value c_reportcount">{{ countMoneyHead.iCounts }}</span>
                                <span class="ratio">同比 {{ countMoneyHead.sProjectRate }}</span>
                                <i class="iconfont icon-iconfont_up"
                                    :class="{ 'icon-iconfont_down1': countMoneyHead.iCountType == '2' }">
                                </i>
                            </p>
                        </div>
                        <div class="item">
                            <p class="label">{{ currentYear }}年企业中标项目销售额({{ countMoneyHead.sBidHeader }})</p>
                            <p>
                                <span class="value c_reportmoney">{{ countMoneyHead.BidAmount }}</span>
                                <span class="ratio">同比 {{ countMoneyHead.sBidRate }}</span>
                                <i class="iconfont icon-iconfont_up"
                                    :class="{ 'icon-iconfont_down1': countMoneyHead.iAmountType == '2' }">
                                </i>
                            </p>
                        </div>
                    </div>
                    <div class="chartsBox">
                        <Echarts :options="getOptions('base', lineBarchartsData)"></Echarts>
                    </div>
                </div>
                <div class="box_map">
                    <Loading v-if="spreadLoading" :isMask="true"></Loading>
                    <!-- 地图 -->
                    <div class="map-content" ref="myMap"></div>

                    <div class="mapTitle">{{ currentYear }}年企业中标项目分布</div>
                    <div class="hotmapList">
                        <div class="item head mb_10">
                            <span>城市</span>
                            <span>项目数</span>
                        </div>
                        <div class="hotmapList_main" v-if="companyHomeSpreadData && companyHomeSpreadData.length">
                            <ScrollBox :autoplay='false'>
                                <ul slot="main">
                                    <li class="item" :class="{ 'active': activeCity == item.CityCaption }"
                                        v-for="(item, index) in companyHomeSpreadData" :key="index"
                                        @click="onHotmap(item)">
                                        <span>{{ item.CityName }}</span>
                                        <span>{{ item.count }}</span>
                                    </li>
                                </ul>
                            </ScrollBox>
                        </div>
                        <!-- <ul class="hotmapList_main">
                            <li class="item" v-for="(item,index) in projectSpreadData" :key="index">
                                <span>{{item.CityCaption}}</span>
                                <span>{{item.count}}</span>
                            </li>
                        </ul> -->
                    </div>
                </div>
            </div>
            <div class="main--right">
                <div class="box_normal special h_right_top subscript right_bottom left_top mb_15">
                    <div class="box_unit_title mb_15">{{ currentYear }}年度落地合作项目占比 TOP10</div>
                    <Loading v-if="parProjectLoading"></Loading>
                    <template v-else>
                        <ul v-if="partnerProjectData && partnerProjectData.aList"
                            class="progressbarList partnerMain_right mt_5">
                            <li class="item" v-for="(item, index) in partnerProjectData.aList" :key="index">
                                <div class="label">{{ item.companyName }}</div>
                                <div class="valueBar flex_align">
                                    <div class="innerBar orange"
                                        :style="{ 'width': !Number(item.iThisCoverCnt) ? '0' : (item.iThisCoverCnt / maxProjectValue * 100) + '%' }">
                                    </div>
                                    {{ item.iThisCoverCnt }}
                                </div>
                                <div class="value">
                                    {{ item.iRange }}
                                    <i class="iconfont" :class="{
                                        'icon-iconfont_up': item.iRangeType == 1,
                                        'icon-iconfont_down1': item.iRangeType == 2,
                                    }"></i>
                                </div>
                            </li>
                        </ul>
                        <Empty v-else></Empty>
                    </template>
                </div>
                <div class="box_normal h_right_bottom subscript right_bottom left_top">
                    <div class="box_news_title">战略合作伙伴动态</div>
                    <Loading v-if="newsLoading"></Loading>
                    <template v-else>
                        <Empty v-if="!partnerNewListCount"></Empty>
                        <template v-else>
                            <swiper class="box_partner_wrap" :options="swiperOption" ref="swiperOption">
                                <!-- slides -->
                                <swiper-slide v-for="(list, index) in partnerNewList" :key="index">
                                    <div class="box_partner c_pointer" @click="toNewsDetail(list.StrokeNewsId)">
                                        <div class="item">
                                            <p class="title">{{ list.title }}</p>
                                            <p class="con">{{ list.content }}</p>
                                            <div class="footer flex_justify_between mt_20">
                                                <button class="tipBtn">{{ list.companyName }}</button>
                                                <p class="c_999">{{ list.date }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="box_partner_footer">
                                <i class="el-icon-arrow-left icon_l" id="arrowL"></i>
                                共{{ partnerNewListCount }}条
                                <i class="el-icon-arrow-right icon_r" id="arrowR"></i>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import getCharts from "@/utils/getCharts.js";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ajaxService from '@/server/api.js'
import chartSet from "@/config/chartSet";
import permission from "@/mixins/permission.js";
import Empty from "@/components/Empty";
import Loading from "@/components/Loading";
import { loadAmap, createFullscreenAmap, createCountryDistrictLayer, bd09ToGcj02 } from "@/utils/amapCommon.js";
import { buildReportDemoData } from "@/utils/reportDemoData.js";

import Util from "@/utils/Util.js"

const REPORT_MAP_CENTER = [104.195397, 35.86166];
const REPORT_MAP_ZOOM = 5;

export default {
    mixins: [permission],
    data() {
        return {
            map: null,
            AMap: null,
            districtLayer: null,
            districtSearch: null,
            heatmapLayer: null,
            cityHighlightPolygons: [],
            isMapReady: false,
            partnerBuildData: {},//获取合作伙伴的开工建面排行
            partnerProjectData: {},//获取公司合作伙伴落地项目前10
            companyHomeSpreadData: [],//企业中标分布（热力图）
            companyPartnerCoverData: {},//百强房企合作占比（水滴图）
            countMoneyHead: {},//当年企业中标项目数量，销售额 还有环比（折柱图-头部）
            countMoneyChart: [],//当年企业中标项目数量，销售额 还有环比（折柱图-图表）
            partnerNewList: [],//合作伙伴动态列表
            partnerNewListCount: 0,//合作伙伴动态列表 数量
            swiperOption: {//合作伙伴动态列表 swiper 配置
                navigation: {
                    nextEl: '#arrowR',
                    prevEl: '#arrowL',
                    disabledClass: 'disabled',
                },
                slidesPerView: 1,
                slidesPerColumn: 2,
                autoplay: {
                    delay: 3000,
                    // stopOnLastSlide: false,
                    // disableOnInteraction: true,
                },
            },
            activeCity: '',
            logo: '',
            currentYear: '',
            parBuildLoading: false, // 我的战略伙伴开工建面
            parProjectLoading: false, // 落地合作项目占比 TOP10
            countMoneyLoading: false, // 企业中标项目数量&销售额
            coverLoading: false, // 百强房企战略合作占比
            newsLoading: false, // 战略合作伙伴动态
            spreadLoading: false, // 企业中标项目分布-热力学图
            maxProjectValue: 0,
            isDemoMode: false
        }
    },
    components: {
        Echarts,
        swiper,
        swiperSlide,
        Empty,
        Loading
    },
    computed: {
        lineBarchartsData() {//折柱图data
            let obj = {
                xAxisData: [],
                barObj: {
                    name: this.currentYear + '年企业中标项目数量',
                    data: [],
                    unit: this.countMoneyHead.sProjectHeader
                },
                lineObj: {
                    name: this.currentYear + '年企业中标项目销售额',
                    data: [],
                    unit: this.countMoneyHead.sBidHeader
                },
            }
            if (this.countMoneyChart && this.countMoneyChart.length) {
                this.countMoneyChart.forEach(item => {
                    obj.xAxisData.push(item.sCateDesc)
                    obj.barObj.data.push(item.iCnt)
                    obj.lineObj.data.push(item.BidAmount)
                })
            }
            return chartSet.reportLineBarChart(obj)
        },
        yearOptions() {
            const curYear = Util.getFullYear() || ''
            const tempArr = new Array(3).fill(curYear).map((item, idx) => item = item - idx)
            let yearArr = tempArr.map(item => {
                return { value: item, label: item }
            })
            return yearArr
        }
    },
    watch: {
        $route() {
            const nextDemoMode = this.resolveDemoModeFromRoute();
            if (nextDemoMode !== this.isDemoMode) {
                this.isDemoMode = nextDemoMode;
                this.getInitData();
            }
        }
    },
    mounted() {
        this.currentYear = Util.getFullYear()
        this.isDemoMode = this.resolveDemoModeFromRoute();
        // this.currentYear = this.currentYear - 1;

        this.initAmap()
        this.getInitData()//获取数据
        document.title = "我的业绩报告 - 优采大数据"
    },
    methods: {
        resolveDemoModeFromRoute() {
            const query = (this.$route && this.$route.query) || {};
            const routeFlag = query.demo || query.demoMode || query.mode || '';
            const value = String(routeFlag).toLowerCase();
            return ['1', 'true', 'yes', 'on', 'demo', 'presentation'].includes(value);
        },
        clearLoadingState() {
            this.parBuildLoading = false;
            this.parProjectLoading = false;
            this.countMoneyLoading = false;
            this.coverLoading = false;
            this.newsLoading = false;
            this.spreadLoading = false;
        },
        applyDemoData() {
            const demoData = buildReportDemoData(this.currentYear, Util.getFullYear());

            this.logo = demoData.logo;
            this.partnerBuildData = demoData.partnerBuildData;
            this.partnerProjectData = demoData.partnerProjectData;
            this.companyHomeSpreadData = demoData.companyHomeSpreadData;
            this.companyPartnerCoverData = demoData.companyPartnerCoverData;
            this.countMoneyHead = demoData.countMoneyHead;
            this.countMoneyChart = demoData.countMoneyChart;
            this.partnerNewList = demoData.partnerNewList;
            this.partnerNewListCount = demoData.partnerNewListCount;
            this.maxProjectValue = demoData.maxProjectValue;
            this.clearLoadingState();
            this.tryRenderSpreadMap();
        },
        async initAmap() {
            try {
                const AMap = await loadAmap({
                    plugins: ['AMap.Scale', 'AMap.DistrictSearch', 'AMap.HeatMap'],
                });

                if (this._isDestroyed || this._isBeingDestroyed || !this.$refs.myMap) {
                    return;
                }

                this.AMap = AMap;
                this.map = createFullscreenAmap(AMap, this.$refs.myMap, {
                    center: REPORT_MAP_CENTER,
                    zoom: REPORT_MAP_ZOOM,
                });

                this.districtSearch = new AMap.DistrictSearch({
                    level: 'city',
                    subdistrict: 0,
                    extensions: 'all',
                    showbiz: false,
                });
                this.heatmapLayer = new AMap.HeatMap(this.map, {
                    radius: 42,
                    opacity: [0.15, 0.9],
                    zooms: [3, 18],
                    zIndex: 120,
                    gradient: {
                        0.2: 'rgba(0, 255, 255, 0.35)',
                        0.45: 'rgba(0, 194, 255, 0.55)',
                        0.65: 'rgba(0, 255, 153, 0.75)',
                        0.82: 'rgba(255, 214, 0, 0.88)',
                        1.0: 'rgba(255, 102, 0, 0.95)',
                    },
                });

                this.drawAllProvinceBoundaries();
                this.isMapReady = true;
                this.tryRenderSpreadMap();
            } catch (error) {
                console.error('高德地图初始化失败', error);
            }
        },
        drawAllProvinceBoundaries() {
            if (!this.AMap || !this.map) {
                return;
            }

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = createCountryDistrictLayer(this.AMap, this.map, {
                'nation-stroke': 'rgba(74, 85, 104, 0.8)',
                'coastline-stroke': 'rgba(74, 85, 104, 0.8)',
                'province-stroke': 'rgba(74, 85, 104, 0.55)',
                fill: 'rgba(74, 85, 104, 0.03)',
            });
        },
        clearSpreadMap() {
            if (this.heatmapLayer) {
                this.heatmapLayer.setDataSet({
                    data: [],
                    max: 0,
                });
            }

            if (this.map && this.cityHighlightPolygons.length) {
                this.map.remove(this.cityHighlightPolygons);
            }

            this.cityHighlightPolygons = [];
        },
        destroyMap() {
            this.clearSpreadMap();

            if (this.districtLayer && this.districtLayer.setMap) {
                this.districtLayer.setMap(null);
            }

            this.districtLayer = null;
            this.districtSearch = null;
            this.heatmapLayer = null;
            this.isMapReady = false;

            if (this.map) {
                this.map.destroy();
            }

            this.map = null;
            this.AMap = null;
        },
        parseCityPoint(item) {
            const lng = parseFloat(item.lng);
            const lat = parseFloat(item.lat);
            if (isNaN(lng) || isNaN(lat)) {
                return null;
            }
            return bd09ToGcj02(lng, lat);
        },
        getCityDisplayName(city) {
            return city.CityName || city.CityCaption || '';
        },
        getCitySearchKeyword(city) {
            return city.CityCaption || city.CityName || '';
        },
        renderHeatMap(cityData) {
            if (!this.map || !this.AMap || !this.heatmapLayer) {
                return;
            }

            this.clearSpreadMap();
            const heatmapData = cityData.map(city => {
                const point = this.parseCityPoint(city);
                if (!point) {
                    return null;
                }
                return {
                    lng: point[0],
                    lat: point[1],
                    count: Number(city.count) || 1,
                };
            }).filter(Boolean);

            const maxCount = Math.max(...heatmapData.map(item => item.count), 1);
            this.heatmapLayer.setDataSet({
                data: heatmapData,
                max: maxCount,
            });
        },
        highlightCityBoundary(city) {
            if (!this.districtSearch || !this.map || !this.AMap) {
                return;
            }

            if (this.cityHighlightPolygons.length) {
                this.map.remove(this.cityHighlightPolygons);
                this.cityHighlightPolygons = [];
            }

            const keyword = this.getCitySearchKeyword(city);
            if (!keyword) {
                return;
            }

            this.districtSearch.search(keyword, (status, result) => {
                if (status !== 'complete' || !result || !result.districtList || !result.districtList.length) {
                    return;
                }

                const district = result.districtList[0];
                const boundaries = district.boundaries || [];
                const polygons = boundaries.map(path => new this.AMap.Polygon({
                    path,
                    strokeColor: '#00FFFF',
                    strokeWeight: 2,
                    strokeOpacity: 0.95,
                    fillColor: '#00FFFF',
                    fillOpacity: 0.12,
                    zIndex: 130,
                }));

                if (polygons.length) {
                    this.map.add(polygons);
                    this.cityHighlightPolygons = polygons;
                }
            });
        },
        focusCity(city) {
            this.activeCity = this.getCitySearchKeyword(city);
            const point = this.parseCityPoint(city);
            if (point && this.map) {
                this.map.setZoomAndCenter(8, point);
            }
            this.renderHeatMap(this.companyHomeSpreadData);
            this.highlightCityBoundary(city);
        },
        tryRenderSpreadMap() {
            if (!this.isMapReady || !this.companyHomeSpreadData.length) {
                return;
            }
            const hasActiveCity = this.companyHomeSpreadData.some(item => {
                return this.getCitySearchKeyword(item) === this.activeCity;
            });
            if (!this.activeCity || !hasActiveCity) {
                this.activeCity = this.getCitySearchKeyword(this.companyHomeSpreadData[0]);
            }
            this.renderHeatMap(this.companyHomeSpreadData);
            const currentCity = this.companyHomeSpreadData.find(item => {
                return this.getCitySearchKeyword(item) === this.activeCity;
            }) || this.companyHomeSpreadData[0];
            if (currentCity) {
                this.highlightCityBoundary(currentCity);
            }
        },
        showFullSwiper() {
            this.$emit('showFullSwiper');
        },
        getOptions(echartType, obj) {
            switch (echartType) {
                case 'drop':
                    let dropoption = getCharts.getDropEchart(obj);
                    return dropoption;
                    break;
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                default:
                    break;
            }
        },

        // 最新资讯跳转
        toNewsDetail(id) {
            let href = 'http://data.youcaiyun.com/page/detail?module=4&type=3&id=0&bId=' + id
            window.open(href, this.isScreen ? '_self' : '_blank');
        },
        // 热力图交互
        onHotmap(item) {
            this.focusCity(item);
        },
        getRefreshData() {
            this.spreadLoading = this.parBuildLoading = this.parProjectLoading = this.countMoneyLoading = true
            const parmas = { year: this.currentYear };

            if (this.isDemoMode) {
                this.applyDemoData();
                return;
            }

            // 企业中标分布（热力图）- 真实 API 调用
            ajaxService.getCompanyHomeSpread(parmas).then(res => {
                // console.log('热力图',res)
                this.spreadLoading = false
                if (!res.ErrorCode) {
                    this.companyHomeSpreadData = res.Data;
                    this.tryRenderSpreadMap();
                }
            });

            // 我的战略伙伴开工建面
            ajaxService.getPartnerBuild(parmas).then(res => {
                // console.log('我的战略伙伴开工建面',res)
                this.parBuildLoading = false
                if (!res.ErrorCode) {
                    this.partnerBuildData = res.Data;
                }
            });

            // 落地合作项目占比TOP10
            ajaxService.getCompanyPartnerProject(parmas).then(res => {
                // console.log('落地合作项目占比TOP10',res)
                this.parProjectLoading = false
                if (!res.ErrorCode) {
                    this.partnerProjectData = res.Data;
                    if (res.Data && res.Data.aList) {
                        // let cloneArr = JSON.parse(JSON.stringify(res.Data.aList))
                        // this.maxProjectItem = cloneArr.reduce((a,b) => Number(a.iThisCoverCnt) >= Number(b.iThisCoverCnt) ? a : b )
                        const maxProjectItem = res.Data.aList.reduce((a, b) => Number(a.iThisCoverCnt) >= Number(b.iThisCoverCnt) ? a : b)
                        this.maxProjectValue = maxProjectItem.iThisCoverCnt || 0
                    }
                }
            });

            // 当年企业中标项目数量，销售额 还有环比（折柱图）
            ajaxService.getRecentYearCountAndTotalSale(parmas).then(res => {
                // console.log('折柱图',res)
                this.countMoneyLoading = false
                if (!res.ErrorCode) {
                    this.countMoneyHead = res.Data.AreaAndCount
                    this.countMoneyChart = res.Data.aProject
                }
            });
        },
        getInitData() {
            this.newsLoading = this.coverLoading = true

            if (this.isDemoMode) {
                this.applyDemoData();
                return;
            }

            this.getRefreshData();
            // 企业logo
            ajaxService.getCompanyLogo().then(res => {
                // console.log('企业logo',res)
                if (!res.ErrorCode) {
                    this.logo = res.Data.Logo;
                }
            });

            // 百强房企合作占比（水滴图）
            ajaxService.getCompanyPartnerCover().then(res => {
                // console.log('水滴图',res)
                this.coverLoading = false
                if (!res.ErrorCode) {
                    this.companyPartnerCoverData = res.Data;
                }
            });

            // 获取合作伙伴动态列表
            ajaxService.getCompanyPartnerNew().then(res => {
                // console.log('合作伙伴动态列表',res)
                this.newsLoading = false
                if (!res.ErrorCode) {
                    this.partnerNewList = res.Data.aList;
                    this.partnerNewListCount = res.Data.count;
                }
            });

        },
        changeYear() {
            this.getRefreshData();
        }
    },
    beforeDestroy() {
        this.destroyMap();
    },
}
</script>
<style lang="scss" scoped>
@use '../../assets/styles/mixin' as *;

.fullscreen {
    .main {
        .main--middle {
            width: 54.8vw
        }

        ;

        .main--right {
            width: 20vw
        }

        ;
    }
}

.menu {
    background-image: url('../../assets/imgs/menu_report.png');
}

.year_select_box {
    position: absolute;
    right: 5.8vw; // 4.6
    bottom: 0.54vh;
    display: flex;
    align-items: flex-end;
    height: 40px; // 46 23
    width: 2.73rem; // 182 91
    max-width: 182px;

    ::v-deep {
        .el-input__inner {
            background-color: rgba(23, 45, 80, .65);
            border-color: #9E7D82;
            color: #fff;
            font-size: 16px;
            border-radius: 40px;
            height: 40px;
            padding-left: 22px;
            line-height: 40px;
        }

        .el-input__suffix {
            right: 15px;
        }

        .el-select__caret {
            color: #FCE5BC;
        }

        .el-input.is-focus .el-input__inner {
            border-color: #9E7D82;
        }
    }
}

::v-deep .el-select-dropdown__wrap {
    background-color: rgba(23, 45, 80, .65);
}

::v-deep .year_select_dropdown {
    background-color: rgba(23, 45, 80, .65);
}

header {
    height: 10vh;
    box-sizing: border-box;
    padding-top: 2.4vh;
    position: relative;

    .logo--company {
        width: 1.02rem;
        height: .66rem;
        border: .03rem solid #FBE7BF;
        border-radius: .03rem;
        background: rgba($color: #FCD6BE, $alpha: .37);
        box-sizing: border-box;
        padding: .07rem;

        .pic {
            width: 100%;
            height: 100%;
            background: #00A1FF;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .title {
        font-size: .4rem;
        font-weight: bold;
        color: #FCE5BC;
    }
}

.box_normal {
    border: .02rem solid rgba($color: #1F1C50, $alpha: 0.5);
    background-color: rgba($color: #010b10, $alpha: 0.2);

    &.special {
        background-color: rgba($color: #010b10, $alpha: 0.35);

        .progressbarList .item {
            height: 3.2vh;
        }

        .progressbarList .item .valueBar {
            height: 35%;
        }

        .progressbarList .item .value {
            min-width: 60px;
        }
    }
}

.box_chart--doubleLine {
    border: none;
    background: none;
    height: 27.4vh;

    .detailBox {
        text-align: center;

        .item {
            float: none;
            display: inline-block;

            .label {
                font-size: .2rem;
            }
        }
    }
}

.box_map {
    position: relative;
    background: none;
    border: none;
    overflow: hidden;
}

.map-content {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.h_left_top {
    height: 53.5vh;
}

.h_left_bottom {
    height: 28.5vh;
}

.h_right_top {
    height: 40vh;
}

.h_right_bottom {
    height: 42.4vh;
}

.mapTitle {
    width: 100%;
    height: .48rem;
    line-height: .48rem;
    font-size: .2rem;
    font-weight: bold;
    background: url('../../assets/imgs/report_mapTitle.png') 0 0 no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    color: white;
    text-align: center;
    z-index: 8;
}

.box_partner_wrap {
    .swiper-slide {
        &:nth-child(2n) {
            .box_partner {
                .item {
                    border-bottom: none;
                }
            }
        }
    }
}

.box_partner {
    width: 100%;
    // height: 32vh;
    height: 16vh;
    box-sizing: border-box;
    padding: 0 .2rem;

    .item {
        box-sizing: border-box;
        border-bottom: .01rem solid #03EDFF;
        // height: 48%;
        height: 98%;
        color: white;
        line-height: 2;
        padding-top: .1rem;

        // &:last-child{
        //     border-bottom: none;
        // }
        .title {
            font-size: .18rem;
        }

        .con {
            font-size: .16rem;
            @include text_clamp(2);
        }

        .footer {
            .tipBtn {
                // width: .56rem;
                // height: .3rem;
                // background: url('../../assets/imgs/btn.png') 0 0 no-repeat;
                // background-size: 100% 100%;
                line-height: .3rem;
                text-align: center;
                color: white;
                font-size: .14rem;

                background-color: rgba($color: #086e8c, $alpha: 0.6);
                border: .01rem solid rgba($color: #00e4e5, $alpha: 0.6);
                border-radius: .04rem;
                padding: 0 .05rem;
            }
        }
    }
}

.box_partner_footer {
    box-sizing: border-box;
    padding: 0 .2rem;
    text-align: center;
    position: relative;
    font-size: .14rem;
    color: white;

    .icon_l,
    .icon_r {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #00FFFF;
        font-weight: bold;
        outline: none;

        &.disabled {
            color: #ADAFB2;
        }
    }

    .icon_l {
        left: .2rem;
    }

    .icon_r {
        right: .2rem;
    }
}

.partnerMain_left {
    height: 47vh;
}

.partnerMain_right {
    height: 33vh;
}


.subscript {

    &::after,
    &::before {
        border: .01rem solid rgba($color: #42B7F4, $alpha: 1);
    }

    // 位置
    &.right_bottom {

        //右下角
        &::after {
            right: -.01rem;
            bottom: -.01rem;
            border-left: none;
            border-top: none;
            display: block;
        }
    }

    &.left_top {

        //左上角
        &::before {
            left: -.01rem;
            top: -.01rem;
            border-right: none;
            border-bottom: none;
            display: block;
        }
    }
}

.progressbarList {
    .item {
        .valueBar {
            background: #302630;
            margin: 0 6px;

            .innerBar {

                // 带分割线
                .innerSplit {
                    background: url('../../assets/imgs/land_bar_split2.png') 0 0 repeat-x;
                    background-size: .12rem 100%;
                }
            }
        }

        .label {
            min-width: 50px;
        }
    }
}

.hotmapList {
    background: rgba($color: #0b163b, $alpha: 0.9)
}
</style>
